export const searchSchema = [
  {
    itemName: 'name',
    label: '企业名称',
    allowClear: true,
    type: 'input',
  },
  {
    itemName: 'code',
    label: '企业ID',
    allowClear: true,
    type: 'input',
  },
  {
    itemName: 'date',
    label: '申请日期',
    type: 'rangePicker',
    allowClear: true,
  },
  {
    itemName: 'id',
    label: '申请流水号',
    allowClear: true,
    type: 'input',
  },
]
export const searchData = {
  name: '',
  code: '',
  id: '',
  date: [],
}
export const pageData = {
  pageSize: 10,
  current: 1,
  total: 0,
}
export const columns = [
  {
    title: '序号',
    width: 70,
    dataIndex: 'order',
    fixed: 'left',
    align: 'center',
    slots: { title: 'customTitile' },
    customRender: (text, record, index) =>
      (pageData.current - 1) * pageData.pageSize + (index + 1),
    // scopedSlots: { customRender: 'order'}
  },
  {
    title: '企业ID',
    dataIndex: 'companyCode',
    width: 250,
  },
  {
    title: '企业名称',
    dataIndex: 'companyName',
    width: 150,
  },
  {
    title: '申请流水号',
    dataIndex: 'bpmId',
    width: 250,
  },
  {
    title: '申请人',
    dataIndex: 'applyPerson',
    width: 150,
  },
  {
    title: '申请日期',
    dataIndex: 'applyDate',
    width: 150,
  },
  {
    title: '审批状态',
    dataIndex: 'statusStr',
    width: 150,
  },
  {
    title: '文件编号',
    dataIndex: 'code',
    width: 150,
  },
  {
    title: '文件名称',
    dataIndex: 'fileName',
    width: 150,
  },
  {
    title: '担保类型',
    dataIndex: 'typeStr',
    width: 150,
  },
  {
    title: '保证书类型',
    dataIndex: 'bookTypeStr',
    width: 150,
  },
  {
    title: '担保方名称',
    dataIndex: 'assuranceName',
    width: 150,
  },
  {
    title: '担保个人身份',
    dataIndex: 'identityStr',
    width: 150,
  },
  {
    title: '上市公司',
    dataIndex: 'isListedStr',
    width: 150,
  },
  {
    title: '上市公司担保公告',
    dataIndex: 'assureNoticeStr',
    width: 150,
  },
  {
    title: '书面担保金额',
    dataIndex: 'writtenAmount',
    scopedSlots: { customRender: 'writtenAmount' },
    width: 150,
  },
  {
    title: '有效担保金额',
    scopedSlots: { customRender: 'validAmount' },
    dataIndex: 'validAmount',
    width: 150,
  },
  {
    title: '货币',
    dataIndex: 'currencyUnitStr',
    width: 150,
  },
  {
    title: '担保生效日期',
    dataIndex: 'efficientDate',
    width: 150,
  },
  {
    title: '担保到期日期',
    dataIndex: 'expireDate',
    width: 150,
  },
  {
    title: '操作',
    fixed: 'right',
    width: 200,
    dataIndex: 'action',
    slotName: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
